import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import Form from "react-bootstrap/Form";
import styled from "styled-components";

import LoginRegisterContainer from "../components/LoginRegisterContainer";

import { EMAIL_REGEX } from "../constants/index";

import mailBigIcon from "../assets/icons/mail_big_icon.svg";

import { useForm } from "react-hook-form";
import {
  forgetPasswordRequest,
  removeUserOtpToken,
} from "../apis/authentications";

// Cookies
import Cookies from "js-cookie";

function ForgotPassword() {
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    formState: { errors, isDirty, isValid, isSubmitting },
  } = useForm({ mode: "onChange" });
  const handleError = (errors) => {};

  const userOtpToken = Cookies.get("uto");

  const innerWidth = window.innerWidth;

  const formOptions = {
    email: {
      required: "Email is required",
      pattern: {
        value: EMAIL_REGEX,
        message: "Invalid email address",
      },
    },
  };

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [isSentLink, setSentLink] = useState(false);
  const [email, setEmail] = useState("");

  function showAlert(text, type) {
    if (type === "success") {
      setError("");
      setSuccess(text);
    } else {
      setSuccess("");
      setError(text);
    }
  }

  async function handleForgotPassword(data) {
    setEmail(data.email);
    setIsLoading(true);
    try {
      const res = await forgetPasswordRequest({ email: data.email });
      showAlert("We have sent you a link to reset your password", "success");
      setSentLink(true);
      setIsLoading(false);
    } catch (err) {
      console.log(err, "error line 71 forgotPassword.js ");
      setIsLoading(false);
      showAlert(err.response.data.message, "error");
    }
  }

  function renderSentLink() {
    return (
      <>
        <img
          src={mailBigIcon}
          alt="google_logo"
          height={innerWidth && innerWidth < 768 ? 170 : 220}
          width={innerWidth && innerWidth < 768 ? 160 : 210}
          objectFit="scale-down"
        />
        <Text innerWidth={innerWidth}>Email sent</Text>
        <SmallText innerWidth={innerWidth}>
          Check your inbox to reset password
        </SmallText>
        <p
          style={{
            width: innerWidth && innerWidth < 768 ? "86%" : "80%",
            textAlign: "center",
            marginBottom: "48px",
            fontWeight: 500,
            textAlign: innerWidth && innerWidth < 768 ? "left" : "",
            fontSize: innerWidth && innerWidth < 768 ? "14px" : "",
          }}
        >
          an email has been sent to {email} with a link to reset your password.
          If you have not received your email after few minutes, please do check
          your spam folder.
        </p>
        <SubmitButton
          onClick={() => navigate("/login")}
          innerWidth={innerWidth}
        >
          Okay, got it
        </SubmitButton>
      </>
    );
  }

  function renderEmailInput() {
    return (
      <>
        <h1
          style={{
            fontSize: 22,
            textAlign: "center",
            marginBottom: "2rem",
          }}
        >
          Forgot your Password?
        </h1>
        <ForgotPasswordForm
          onSubmit={handleSubmit(handleForgotPassword, handleError)}
        >
          <Form.Group
            style={{
              width: innerWidth && innerWidth < 768 ? "95%" : "80%",
              textAlign: "left",
            }}
          >
            <Form.Label>Email address</Form.Label>
            <FormControl
              id="email"
              type="email"
              name="email"
              placeholder="yourname@mail.com"
              error={errors?.email}
              {...register("email", formOptions.email)}
            />
            <small className="text-danger">
              {errors?.email && errors.email.message}
            </small>
          </Form.Group>
          <div
            style={{
              width: innerWidth && innerWidth < 768 ? "95%" : "80%",
              textAlign: innerWidth && innerWidth < 768 ? "left" : "",
            }}
          >
            <p>
              Enter the email address you used when you joined Combined Clinics
              Sustainability and we&apos;ll send you instructions to reset your
              password.
            </p>
            <p>
              For security reasons, we do NOT store your password. So rest
              assured that we will never send your password via email.
            </p>
          </div>
          <SubmitButton
            disabled={isLoading || !isDirty || !isValid || isSubmitting}
            variant="primary"
            type="submit"
            innerWidth={innerWidth}
          >
            Send reset instructions
          </SubmitButton>
        </ForgotPasswordForm>
      </>
    );
  }

  const handleRemoveUserOtpToken = async () => {
    try {
      await removeUserOtpToken();
    } catch (err) {
      console.log(err, "error line 182 forgotPassword.js <<");
    }
  };

  useEffect(() => {
    if (userOtpToken) {
      handleRemoveUserOtpToken();
    }
  }, [userOtpToken]);

  return (
    <LoginRegisterContainer
      isLoading={isLoading}
      error={error}
      success={success}
    >
      {isSentLink ? renderSentLink() : renderEmailInput()}
    </LoginRegisterContainer>
  );
}

export default ForgotPassword;

const Text = styled.h1`
  font-size: ${({ innerWidth }) =>
    innerWidth && innerWidth < 768 ? "30px" : "36px"};
  text-align: center;
  margin-bottom: 20px;
  color: #00bb99;
  font-weight: bold;
  margin-bottom: 20px;
`;
const SmallText = styled.div`
  font-size: ${({ innerWidth }) =>
    innerWidth && innerWidth < 768 ? "18px" : "22px"};
  font-weight: 500;
  text-align: center;
  margin-bottom: 20px;
`;

const ForgotPasswordForm = styled(Form)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 1rem;
  align-items: center;
  width: 80%;
  height: 100%;
  margin: 0 auto;
  margin-top: 1rem;
`;

const FormControl = styled(Form.Control)`
  border: ${({ error }) => (error ? "2px solid #EB4335" : "2px solid #00BB99")};
  background-color: ${({ error }) => (error ? "#FFE1E1" : "transparent")};
  border-radius: 10px;
`;

const SubmitButton = styled.button`
  font-size: ${({ innerWidth }) =>
    innerWidth && innerWidth < 768 ? "15px" : "18px"};
  font-weight: bold;
  color: white;
  background: #00bb99;
  border: #00bb99;
  border-radius: 40px;
  filter: drop-shadow(0 25px 25px rgb(0 0 0 / 0.15));
  :hover {
    background: #00bb99;
    cursor: ${({ disabled }) => !disabled && "pointer"};
    opacity: ${({ disabled }) => (disabled ? 0.5 : 0.8)};
  }
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
  min-width: 160px;
  min-height: 40px;
  padding: 0.5rem 1rem;
`;
